import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiArrowLeft } from 'react-icons/hi';

const Terms = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="w-full min-h-screen bg-[#0b1120] text-gray-300 py-16 px-4 md:px-12 flex flex-col items-center">
            <div className="max-w-[800px] w-full">
                <Link
                    to="/"
                    className="inline-flex items-center text-[#64ffda] hover:underline mb-8 font-medium transition-colors"
                >
                    <HiArrowLeft className="mr-2" /> Back to Home
                </Link>

                <h1 className="text-4xl sm:text-5xl font-bold text-gray-100 border-b-4 border-[#15434e] pb-4 mb-8">
                    Terms & Conditions
                </h1>

                <p className="text-sm text-gray-400 mb-6">Last Updated: September 2026</p>

                <section className="space-y-6 text-gray-300 leading-relaxed">
                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">1. Agreement to Terms</h2>
                        <p>
                            By accessing and using this portfolio website (https://sharvansamala.com), you agree to comply with and be bound by these Terms and Conditions.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">2. Intellectual Property</h2>
                        <p>
                            All code, project demonstrations, design assets, and content on this website are the personal and professional intellectual property of Sharvan Samala unless otherwise noted. Open-source repositories linked are distributed under their specified open-source licenses (e.g. MIT, Apache 2.0).
                        </p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">3. Prohibited Use</h2>
                        <p className="mb-2">When using this site, you agree not to:</p>
                        <ul className="list-disc list-inside space-y-1 pl-4 text-gray-400">
                            <li>Engage in automated scraping, spamming, or abuse of the contact form.</li>
                            <li>Attempt to compromise the security or availability of the website.</li>
                            <li>Misrepresent affiliation or ownership of the showcased projects.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">4. External Links Disclaimer</h2>
                        <p>
                            This website may contain links to external third-party websites or services (e.g., GitHub repositories, live demo deployments, LinkedIn). Sharvan Samala is not responsible for the content, privacy practices, or availability of any third-party websites.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">5. Disclaimer of Warranties</h2>
                        <p>
                            This website and its portfolio projects are provided "as is" for informational and demonstration purposes without warranties of any kind.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">6. Contact</h2>
                        <p>
                            If you have any questions regarding these terms, please contact{' '}
                            <a href="mailto:samalasharvan@gmail.com" className="text-[#64ffda] hover:underline">
                                samalasharvan@gmail.com
                            </a>.
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Terms;
